module.exports = __webpack_public_path__ + "img/inscription-delete.4c415263.svg";